import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';

import { QuestionReviewTaskCreationSelectedRowsContext } from './question-review-task-creation-form-provider';
import type { QuestionReviewTaskCreationFormInput } from './question-review-task-creation-form-schema';

export const useQuestionReviewTaskCreationFormContext =
  useFormContext<QuestionReviewTaskCreationFormInput>;

export function useQuestionReviewTaskCreationSelectedRowsContext() {
  const context = useContext(QuestionReviewTaskCreationSelectedRowsContext);

  if (!context) {
    throw new Error(
      'useQuestionReviewTaskCreationSelectedRowsContext must be used within QuestionReviewTaskCreationFormProvider',
    );
  }

  return context;
}
